import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../Styles/WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "+91 6305877759"; 

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <FaWhatsapp size={40} />
    </a>
  );
};

export default WhatsAppButton;
